import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import type { QueueEntryResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The player's queue entry (GET /queue/{entry_id} → QueueEntryResponse).
 *
 * Drives the waiting view's position + estimated wait, and the status flip that
 * advances the player to the "you're up" surface. The facility court-state
 * stream invalidates this key after queue or assignment mutations.
 */
export function useQueueEntry(entryId: string) {
  return useQuery<QueueEntryResponse>({
    queryKey: queryKeys.dropin.queueEntry(entryId),
    queryFn: () => queueApi.getStatus(entryId),
    enabled: Boolean(entryId),
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
  });
}
